import { types } from './types';

export const setGetEventsAction = (payload) => {
  return {
    type: types.SET_GET_EVENTS,
    payload,
  }
}